{
  "button": {
    "collapse_goods_details": "收起商品",
    "use_now": "立即使用",
    "cancel": "取消",
    "confirm": "确认",
    "get_code": "获取验证码",
    "resend_code": "重新发送验证码",
    "chat_kakao": "联系客服",
    "my_address": "获取集运仓地址",
    "logout": "退出登录",
    "address_title": "转运地址",
    "delivery_fee_chart": "运费标准表",
    "address_book": "地址栏",
    "search": "搜索",
    "tracking_all": "查看全部",
    "tracking_missing": "查看未填写追踪单的订单",
    "download_excel": "下载",
    "add_tracking": "添加追踪号",
    "use_all_deposit": "使用全部预存款",
    "use_all_point": "使用全部积分",
    "use_member_name": "使用会员姓名",
    "payment": "支付",
    "reset": "重置",
    "apply_deposit": "申请预存款",
    "request_refund": "申请退款",
    "convert_currency": "申请人民币预存款（人民币 → 韩元转换）",
    "delete": "删除",
    "mark_as_read": "标记为已读",
    "close": "关闭",
    "change_password": "修改密码",
    "select_image": "选择图片",
    "edit_info": "修改信息",
    "withdraw": "注销账户",
    "edit_btn": "编辑",
    "edit": "修改",
    "copy": "复制",
    "add_new_address": "新增收货地址",
    "edit_address": "修改收货地址",
    "set_default_address": "设置为默认地址",
    "cancel_default_address": "取消默认地址",
    "use_address": "使用地址",
    "add": "添加",
    "add_all": "批量添加",
    "batch_upload": "批量上传",
    "sku_batch_upload_template": "SKU批量上传模板下载",
    "batch_order": "返送订单下单",
    "without_track_no_all": "快递单号未填",
    "view_all_list": "全部",
    "search_zipcode": "搜索邮编",
    "check_customs_code": "个人通关号查询",
    "confirm_customs_code": "确认个人通关号准确性",
    "complete_customs_code_verification": "请先完成个人通关号验证",
    "open_zipcode_popup": "搜索邮编",
    "submit": "提交申请",
    "edit_recipient_info": "修改收件人信息",
    "edit_logistics_info": "修改物流中心信息",
    "add_product": "添加商品",
    "add_sub_tracking": "添加子追踪号",
    "back_to_list": "返回列表",
    "back": "返回",
    "back_to_top": "TOP",
    "more": "更多",
    "delete_order": "删除订单",
    "submit_order": "提交订单",
    "proxy_purchase_cancel": "代买取消",
    "load_data": "注册商品下单",
    "history_order_products": "历史订单下单",
    "get_product_url": "获取商品URL",
    "copy_order_history": "复制订单记录",
    "copy_cart_history": "复制购物车记录",
    "load_inventory": "库存下单",

    "upload_image": "上传图片",
    "register_order": "上传",
    "customs_clearance_list": "目录清关",
    "simple_customs_clearance": "简易清关",
    "enterprise_customs_clearance": "企业清关",
    "customs_clearance_title": "清关信息",
    "pending_submission": "待提交",
    "confirm_submission": "确认提交",
    "next_step": "下一步",
    "get_product_info": "获取商品信息",
    "export_product_info": "导出商品信息",
    "save": "保存",
    "view_detail": "查看详情",
    "view": "查看",
    "order_view": "查看订单",
    "packing_ask_for": "合包要求",

    "split_order": "拆分",
    "merge_order": "合并",
    "ignore_error": "忽略错误",
    "apply_return": "申请退货",
    "edit_additional_service": "修改附加服务",
    "stock_apply": "申请库存",
    "stock_out_order": "库存出库订单",
    "purchase_quote": "代买申请",
    "order_apply": "订单申请",
    "save_completed": "保存完成",
    "other": "其他",
    "set_add": "套装添加",
    "set_composition": "套装构成",
    "img_url": "查看商品",
    "view_all": "查看所有选项",
    "temporary_storage": "临时存储",
    "combined_qty_edit": "合包数量修改",
    "order_excel": "订单下载",
    "view_in_details": "查看入库明细",
    "view_out_details": "查看出库明细",
    "view_details": "查看明细",
    "expand_package_details": "展开包装详情",
    "collapse_package_details": "收起包装详情",
    "operation": "操作",
    "apply_cancellation": "申请废弃",
    "cn_order": "中国订单",
    "kr_order": "韩国订单",
    "all_order": "全部订单",
    "confirm_apply": "确认申请",
    "issue_handling": "问题处理",
    "check_photo": "查看实拍",
    "view_composition": "查看构成",
    "edit_track": "入库单号管理",
    "problem_solving": "问题入库",
    "upload_warehousing_document": "上传入库文件",
    "view_warehousing_document": "查看入库文件",
    "outbound_request": "出库申请",
    "packing_list": "装箱清单",
    "packing_detail_download": "包装明细下载",
    "outbound_real_photos": "出库实拍",
    "generate_return_order": "生成返送订单",
    "outbound_return_apply": "原运单退货申请",
    "product_use_conversion": "上架",
    "business_license_view": "查看营业执照照片"
  },
  "errorInStock": {
    "精密确认": "精密确认",
    "无视错误": "无视错误",
    "重新包装": "重新包装",
    "问题入库操作": "问题入库操作",
    "处理方式": "处理方式",
    "退货信息": "退货信息",
    "退货方式": "方式",
    "使用仓库快递": "使用仓库快递",
    "卖家回收": "卖家回收",
    "取件": "取件",
    "取件码": "取件码",
    "请输入取件码": "请输入取件码",
    "取件日期": "取件日期",
    "请选择取件日期": "请选择取件日期",
    "处理成功": "处理成功",
    "到货数量有误": "到货数量有误",
    "商品破损": "商品破损",
    "商品有误": "商品有误",
    "剩余产品": "剩余产品",
    "代买商品编号": "代买商品编号",
    "请选择要操作的商品": "请选择要操作的商品",
    "请选择要操作的选项": "请选择要操作的选项",
    "没有可补发的订单信息": "没有可补发的订单信息",
    "请选择实际补发订单号": "请选择实际补发订单号",
    "请先添加处理方式": "请先添加处理方式",
    "仅退款": "仅退款",
    "重新检查": "重新检查",
    "补发": "补发"
  },
  "table": {
    "apply_date": "支付日期",
    "resgiter_date": "注册日期",
    "category": "分类",
    "user_name": "操作人",
    "storage_location": "库位",
    "split_order_title": "分单",
    "splite_num_max": "最多可分单数",
    "sku_number_available": "可用库存数量",
    "truck_deliveryService": "基础包装项目",
    "apply_num_select": "申请数量选择",
    "stock_info": "库存信息",
    "stock_warehouse": "库存仓库",
    "stock_quantity": "库存数量",
    "avatar": "图片",
    "product_image": "商品图片",
    "spu_product": "登录商品",
    "product_totals": "商品总数",
    "stock_volume": "库存商品体积",
    "sku_qty": "SKU数量",
    "outbound_qty": "已出库数量",
    "order_info": "订单信息",
    "personal_info": "个人信息",
    "order_count": "订单数量",
    "order": "订单",
    "pay_info": "结款信息",
    "address_info": "地址信息",
    "custom_inquiry": "清关查询",
    "customs_type": "清关方式",
    "warehouse": "仓库",
    "request_type": "申请类别",
    "receiver_payment": "结算方式",
    "outbound_track_no": "出库运单号",
    "domestic_track_no": "国内运单号",
    "fee": "费用",
    "order_date": "下单/修改日期",
    "status": "状态",
    "ware_state_cd": "入库状态",
    "state_seq": "订单状态",
    "upd_date": "修改日期",
    "ins_date": "下单日期",
    "create_date": "创建日期",
    "deposit_date": "入款日期",
    "request_date": "申请日期",
    "product_name": "商品名称",
    "order_svc_name": "附加费用名称",
    "order_no": "订单号 / 快递单号",
    "color": "颜色",
    "size": "尺码",
    "product_qty": "数量",
    "sku_id_info": "SKU ID信息",
    "processing": "处理中",
    "outbound": "已出库",
    "outbound_cancel": "出库取消",
    "outbound_return": "原运单退货",
    "product_total": "合计",
    "order_unit": "单",
    "piece": "件",
    "product_status": "商品状态",
    "stock_status": "库存状态",
    "payment_amount": "结算金额",
    "deduction_amount": "抵扣金额",
    "billing_info": "账单信息",
    "application": "申请记录",
    "refund_details": "退款记录",
    "start_date": "开始日期",
    "used_amount": "使用金额",
    "deposit_amount": "预存款余额",
    "balance_amount": "余额",

    "today_storage_fee": "今日保管费",
    "unpaid_storage_fee_bill_count": "待支付仓储费账单",
    "change_amount": "变动金额",
    "no_data": "暂无数据",
    "coupon_info": "优惠券信息",
    "issuance_date": "发放日期",
    "used_date": "使用日期",
    "remaining_days": "剩余天数",
    "days": "天",
    "title": "标题",
    "author": "作者",
    "write_date": "发布日期",
    "read_status": "阅读状态",
    "unread": "未读",
    "read": "已读",
    "shop_order_no": "平台订单号",
    "shop_url": "商品网址",
    "product_url": "商品网址",
    "image_url": "图片网址",
    "customs_item": "清关代码",
    "price": "单价",
    "total_price": "总价",
    "coupang_number": "入库数量",
    "product_memo": "商品备注",
    "product_tax": "商品税率",
    "warehousing_complete": "入库完成",
    "product_comment": "商品重量/体积",
    "brand": "品牌",
    "views": "浏览数",
    "payment_method": "支付方式",
    "auto_payment": "自动支付",
    "manual_payment": "手动支付",
    "business_platform": "平台类型",
    "sku_composition": "SKU构成信息",
    "age": "未满14岁",
    "limite_term": "有限期限",
    "sku_select_no": "请输入数量(最小数量为1)",
    "invalid_sku_codes": "SKU无效：{codes}",
    "composition": "构成",
    "processing_date": "处理时间",
    "processing_con": "处理内容",
    "combcombination_id": "编号",
    "combcombination_num": "组合数量",
    "origin": "出发地",
    "trk_cnt": "运单数",
    "pro_info_msg": "商品信息（可选择商品进行取消申请）",
    "pro_info": "商品信息",
    "cn_fee": "中国国内运费",
    "shop_order_total_num": "总平台订单号数量",
    "reason_title": "申请理由（单选）",
    "select_reson_msg": "请选择申请理由",
    "detail_memo": "详细理由",
    "detail_memo_init": "请详细说明申请取消订单的理由",
    "select_no_pro": "请至少选择一个商品",
    "auto_select_charge": "已经自动为您选中相关选项。",
    "express": "快递",
    "yes": "是",
    "no": "否",
    "truck_inbound": "是否货车入库",
    "truck": "货车",
    "truck_info": "货车信息",
    "look_trk_no_title": "快递单号查看",
    "express_msg": "请在商品信息中填写快递单号",
    "vehicle_information": "车牌号",
    "driver_telphone": "司机联系方式",
    "pallet_number": "托盘数量",
    "box_number": "箱子数量",
    "arrived_time": "预计收货日期",
    "kr_recipient_msg": "申请韩国3PL中国购入时，默认填写CHINAONE韩国仓库地址。",
    "truck_storage_number": "货车入库编号",
    "slect_time": "选择时间",
    "express_package": "快递件",
    "stock_products": "库存商品",
    "stock_products_no": "非库存商品",
    "stock_products_split": "库存拆分商品",
    "prepay_amount": "预支付金额",
    "return_products": "返送商品",
    "return_from_coupang_method": "处理方式",
    "return_order": "返送订单",
    "coupang_inbound_code": "库彭入库号码",
    "carriage_forward": "到付费用",
    "warehouse_return": "仓库退货"
  },
  "cancel_reasons": {
    "spec_error": "拍错规格 / 型号",
    "duplicate_order": "重复下单",
    "wrong_address": "送错收货信息",
    "info_mismatch": "商品信息不符",
    "stock_issue": "库存 / 发货问题",
    "no_longer_needed": "临时不需要",
    "budget_change": "预算调整",
    "other": "其他原因"
  },
  "common": {
    "createSuccess": "添加成功",
    "noSelection": "暂无可选项",
    "packagRequested": "确定将剩余商品单个包装吗",
    "confirm_msg_packing": "是否确认包装信息",
    "coupang_msg_select": "coupang信息选择",
    "coupang_save": "确认保存coupang信息吗?",
    "updateSuccess": "修改成功",
    "select_no_pack": "请选择要包装的商品",
    "delMessage": "确认要删除吗？",
    "confirmTitle": "系统提示",
    "status2": "已确认",
    "confirm_cancel_yn": "库存商品拆分后无法复原，是否确定拆分",
    "loading": "数据加载中...",
    "confirmMessage": "是否确认操作选中数据？",
    "success": "成功",
    "failed": "失败"
  },
  "goods_shelf": {
    "max_num": "最大值"
  },
  "age_yn": {
    "y": "需要未满14岁标志",
    "n": "不需要未满14岁标志"
  },
  "payment_status": {
    "paid": "结算完成",
    "unpaid": "未结算",
    "pending_deposit": "等待汇款",
    "coupon_title": "代金券"
  },
  "bill_status": {
    "paid": "已支付",
    "unpaid": "未支付",
    "cancelled": "已取消",
    "pending": "待确认",
    "refunded": "全额退款"
  },
  "confirm": {
    "ignore_error": "是否将该商品标记为忽略错误？",
    "apply_ancellation": "是否将该商品申请废弃？",
    "cancel_action": "确定要取消此操作吗？",
    "cancelOutbound": "确定要出库取消吗？",
    "alert_title": "提示",
    "mark_as_read": "是否将所选消息标记为已读？",
    "logout_confirm": "确定要注销会员吗？",
    "logout_description": "注销会员后，当前账号及相关会员信息将被删除，且无法恢复。注销后将无法使用原账号重新登录，也无法再次注册会员。请确认已完成所有订单、退款、余额及其他相关业务处理后再进行注销。",
    "logout_warning": "此操作不可撤销，请谨慎操作。",
    "logout_confirm_button": "确认注销",
    "edit_confirm": "是否要修改？",
    "delete_address": "确定要删除地址吗？",
    "delete_trk": "确定要删除么？",
    "application_for_return": "是否申请原运单退货?",
    "delete_note": "是否要删除所选消息？",
    "submit_order": "是否申请提交？",
    "submit_selected_order": "是否提交该订单？",
    "copy_product": "是否复制该商品？",
    "delete_product": "是否删除该商品？",
    "sync_register_title": "同步注册商品",
    "sync_register_message": "本次订单使用了基础商品，是否同步注册为商品？",
    "sync_register_hint": "同步后，该商品可在“注册商品”中继续使用。",
    "sync_register_only": "仅下单",
    "sync_register_and_order": "同步并下单",
    "sync_register_failed": "同步注册商品失败，请稍后到商品管理中手动注册",
    "sync_register_success": "同步注册商品成功，可在商品管理中查看",
    "sync_register_failed_alert": "同步注册商品失败，订单已创建成功。点击确定前往订单详情页查看。",
    "delete_stock_product": "是否删除所选库存商品？",
    "delete_order": "是否删除该订单？",
    "delete_product_limit_tip": "无法再删除。至少保留一个商品。",
    "save_product": "是否保存？",
    "change_password": "是否修改密码？",
    "confirm_payment": "是否进行付款？",
    "bank_transfer_title": "确认银行卡转账",
    "bank_transfer_amount_tip": "本次需要转账的金额为",
    "bank_transfer_notice": "确认后将生成支付记录，请按页面显示的收款账户完成转账。",
    "select_payment_item_tip": "请选择要付款的申请记录。",
    "split_order": "是否拆分所选商品？",
    "bundle_order": "是否将所选订单进行合并？",
    "delete_file": "是否删除所选文件？",
    "save_coupang_reservation": "是否保存 Coupang 预约信息？",
    "coupon_msg": "该费用已选择代金券，如需更换请先取消",
    "coupon_once": "该代金券已使用",
    "coupon_amount_limit": "代金券金额大于当前账单结算金额，不能使用代金券",

    "used_coupon": "已使用",
    "apply_cancel": "确定要申请取消吗?",
    "order_list_none": "该费用无订单信息"
  },
  "coupang_center": "Coupang 物流中心",
  "please_login_first": "请先登录以使用该服务。",
  "chinaone_login": "ID登录",
  "chinaone_sms_login": "验证码登录",
  "input_userid": "请输入用户名",
  "input_password": "请输入密码",
  "remember_userid": "记住用户名",
  "login_button": "登录",
  "register_button": "注册",
  "find_idpw": "找回 ID/PW",
  "naver": "NAVER",
  "naver_preparing": "准备中",
  "login_with_account": "使用账号登录",
  "userid": {
    "check_memid": "重复检查",
    "required": "请输入用户名",
    "exists": "用户名已存在",
    "available": "用户名可以使用"
  },
  "password": {
    "required": "请输入密码"
  },
  "password_confirm": {
    "required": "请确认密码",
    "msg": "两次输入的密码不一致。"
  },
  "name_ko": {
    "required": "请输入姓名（韩文）"
  },
  "name_en": {
    "required": "请输入姓名（英文）"
  },
  "mobile": {
    "required": "请输入手机号",
    "placeholder": "请输入手机号（不含-）",
    "msg": "请输入有效的手机号",
    "delivery_placeholder": "手机号",
    "required_return": "请输入联系电话"
  },
  "email": {
    "required": "请输入电子邮箱地址",
    "msg": "请输入有效的电子邮箱地址"
  },
  "code": {
    "sms": "请输入手机号",
    "email": "请输入电子邮箱地址",
    "msg": "验证码已发送"
  },
  "business_address": {
    "title": "营业执照地址",
    "required": "请输入营业执照地址."
  },
  "barcode_label_info": {
    "title": "条形码编号详情"
  },
  "certificate_of_origin": {
    "title": "产地证(C/O)",
    "product_name_en": "商品英文名",
    "hs_code": "HS 编码"
  },
  "customs_item": {
    "required": "请选择清关代码"
  },
  "rocket_address_warning": {
    "title": "- 若为火箭申请，收件人地址无法修改。"
  },
  "reset_password": "找回密码",
  "register_form": {
    "login_type_sms": "手机验证码登录",
    "login_type_user": "用户名密码登录",
    "userid": "用户名",
    "userid_rule": "只能使用字母和数字的组合。",
    "password": "密码",
    "password_rule": "密码需至少 6 位字符。",
    "password_confirm": "确认密码",
    "show_password": "显示密码",
    "hide_password": "隐藏密码",
    "name_ko": "姓名（韩文）",
    "name_en_required": "姓名（英文）",
    "mobile": "手机号",
    "mobile_kr_cn": "韩国或中国手机号",
    "verification_code": "验证码",
    "get_verification_code": "获取验证码",
    "verification_code_required": "请输入手机验证码",
    "verification_code_not_sent": "请先获取手机验证码",
    "verification_code_incorrect": "手机验证码不正确",
    "mobile_changed_after_code": "手机号已修改，请重新获取验证码",
    "mobile_verification_required": "请先完成手机号验证",
    "email": "邮箱地址",
    "email_login_tip": "※ 请填写正确的邮箱地址。之后可使用相同邮箱绑定的 Naver 或 Kakao 账号进行快捷登录。",
    "referrer_id": "推荐人用户名",
    "referrer_code": "推荐码",
    "deposit_personal_krw": "个人 - 韩元预存款",
    "deposit_personal_cny": "个人 - 人民币预存款",
    "deposit_business_krw": "企业 - 韩元预存款",
    "deposit_business_cny": "企业 - 人民币预存款",
    "user_type": {
      "title": "个人/企业",
      "placeholder": "请选择用户类型",
      "personal": "个人",
      "business": "企业"
    },
    "deposit_type": {
      "title": "预存款充值类型",
      "placeholder": "请选择预存款充值类型",
      "krw": "韩币预存款充值",
      "cny": "人民币预存款充值"
    },
    "kr_business_info": "韩国营业执照信息",
    "cn_business_info": "中国营业执照信息（企业账户选择人民币充值时，需要填写中国企业信息）",
    "business_phone": {
      "title": "联系电话",
      "placeholder": "请输入联系电话"
    },
    "business_address": {
      "title": "营业执照地址",
      "placeholder": "请输入营业执照地址"
    },
    "business_license": {
      "title": "营业执照照片"
    },
    "upload_license": "上传营业执照",
    "upload_tip": "附件上传大小：1MB",
    "upload_size_limit": "文件大小不能超过1MB",
    "upload_success": "上传成功",
    "cn_business_no": {
      "title": "中国营业执照号码",
      "placeholder": "请输入中国营业执照号码"
    },
    "cn_business_name": {
      "title": "中国企业名称",
      "placeholder": "请输入中国企业名称",
      "user_title": "中国企业信息"
    },
    "cn_business_email": {
      "title": "中国邮箱",
      "placeholder": "请输入中国企业邮箱"
    },
    "sms_agreement": {
      "title": "SMS/同意接收货物状态通知（必选）",
      "info": "订单信息及订单状态等内容(报价、入库、出库、配送、错误）"
    },
    "business_no_kr": "韩国营业执照号码",
    "business_no": {
      "title": "韩国营业执照号码",
      "placeholder": "请输入韩国营业执照号码（不含-）",
      "required": "请输入韩国营业执照号码",
      "mypage": "营业执照号"
    },
    "business_ctms_no": {
      "title": "企业清关号（选填）",
      "placeholder": "请输入企业清关号",
      "tip": "若没有企业清关号，不知道如何申请，请注册后询问客服申请方法，并及时填写，以免影响下单清关。"
    },
    "business_name": {
      "title": "韩国公司名称",
      "placeholder": "请输入韩国公司名称",
      "required": "请输入韩国营业执照号",
      "mypage": "公司名称",
      "overdraft_limit": "保证金金额",
      "user_title": "韩国企业信息",
      "country_kr": "韩文",
      "country_en": "英文"
    },
    "business_name_en": {
      "title": "英文企业名称"
    },
    "legal_representative": {
      "title": "企业法人",
      "placeholder": "请输入企业法人",
      "required": "请输入企业法人"
    },
    "business_file": {
      "title": "营业执照文件"
    },
    "business_email": {
      "title": "公司邮箱",
      "placeholder": "请输入邮箱",
      "required": "用于预存款申请"
    },
    "business_file_kr": "韩国营业执照文件",
    "select_image": "选择图片",
    "tax_invoice": {
      "title": "是否开具税务发票",
      "N": "不开具发票",
      "Y": "开具发票",
      "Ntext": "不开具发票",
      "Ytext": "开具税务发票"
    },
    "terms_of_service": "服务使用条款",
    "required": "（必选）",
    "privacy_policy": "个人信息收集及使用说明",
    "submit_join": "注册"
  },
  "find_password": {
    "description": "请输入注册的手机号码或邮箱并完成身份验证。",
    "code_validity": "验证码仅在有效时间内可用，请及时完成验证。",
    "verification_code_incorrect": "验证码不正确或已失效，请重新输入",
    "get_code_first": "请先获取短信验证码",
    "user_not_found": "未找到该用户，请确认手机号或邮箱是否正确",
    "reset_confirm": "确定要重置密码吗？",
    "reset_success": "密码设置成功，请重新登录。",
    "placeholders": {
      "sms": "请输入注册的电话号码",
      "email": "请输入注册的邮箱",
      "code": "请输入验证码",
      "new_password": "请输入新密码",
      "confirm_password": "请再次输入新密码"
    },
    "button": {
      "submit": "验证"
    }
  },
  "file": {
    "delete_button": "删除文件",
    "upload_limit_msg": "每个文件的最大大小限制",
    "coupang_file_required": "请先上传全部 Coupang 文件",
    "select_file_button": "选择文件",
    "no_file_selected": "未选择任何文件",
    "file_type_f": "物流文件(PDF)",
    "file_type_t": "物流随函(PDF)"
  },
  "email_template": {
    "title": "邮箱验证码",
    "hello": "您好！",
    "verify_request": "请在页面输入以下验证码完成验证。",
    "code_expire": "该验证码将在 :minutes 分钟后失效。",
    "ignore_tips": "如果这不是您本人操作，请忽略此邮件。",
    "contact_tips": "如有任何疑问，请通过以下邮箱联系我们。"
  },
  "quick_btn": {
    "delivery": "申请转运服务",
    "buy": "申请代买服务",
    "excel": "Excel 批量下单",
    "stock": "申请库存管理",
    "3pl": "仓储 (3PL) 服务",
    "shop": "商品管理",
    "shop_desc": "添加、管理商品信息",
    "stock_desc": "实时查看库存状态",
    "shipping_desc": "申请发货、跟踪物流",
    "orders_desc": "查看所有订单记录",
    "mnu1": "中国快递单号查询",
    "mnu2": "运费说明",
    "mnu3": "费用计算器",
    "mnu4": "韩国快递单号查询",
    "mnu5": "日程安排",
    "mnu6": "清关查询",
    "mnu7": "个人清关编码申请",
    "mnu8": "无数据处理方法"
  },
  "nodata_list": {
    "title": "无会员号包裹",
    "korea_title": "韩国无数据",
    "china_title": "中国无数据",
    "empty_hint": "当前暂无仓库相关数据",
    "trk_tit": "快递单号",
    "owner_type": "包裹类型",
    "excel": "Excel 批量下单",
    "stock": "申请库存管理",
    "3pl": "仓储 (3PL) 服务",
    "shop": "商品管理",
    "msg": "没有待付款订单。",
    "addr": "未注册收货地址。",
    "search_addr": "无搜索结果",
    "reg_product": "暂无已注册商品",
    "empty": "暂无相关数据"
  },

  "customsClearanceDialog": {
    "titleExpress": "快递清关查询",
    "titleLcl": "LCL 清关查询",
    "titleDefault": "清关查询",
    "numberExpress": "快递单号",
    "numberLcl": "LCL 提单号",
    "numberDefault": "查询单号",
    "cargoExpress": "快递货物",
    "cargoLcl": "LCL 拼箱货物",
    "cargoDefault": "普通货物",
    "queryFailed": "清关信息查询失败",
    "noData": "未查询到清关信息",
    "cargoInfo": "货物信息",
    "cargoName": "货物名称",
    "cargoType": "货物类型",
    "hblNo": "HBL号",
    "mblNo": "MBL号",
    "cargoManagementNo": "货物管理号",
    "packageCount": "件数",
    "totalWeight": "总重量",
    "weight": "重量",
    "volume": "体积",
    "containerNo": "集装箱号",
    "containerCount": "集装箱件数",
    "transportCategory": "运输分类",
    "transportInfo": "运输信息",
    "shipName": "船名",
    "shipNationality": "船籍",
    "arrivalDate": "入港日期",
    "loadingPort": "装货港",
    "dischargePort": "卸货港",
    "arrivalCustoms": "入港海关",
    "shippingCompany": "船公司",
    "forwarder": "货运代理",
    "agency": "代理机构",
    "lastProcessedAt": "最近处理时间",
    "releaseWithinDeadline": "放行期限内通过",
    "declarationDelaySurtax": "申报延迟附加税",
    "progress": "清关进度",
    "progressCount": "共 {count} 条",
    "noProgress": "暂无清关进度",
    "declarationNo": "申报号",
    "location": "场所",
    "moveDateTime": "搬入/搬出时间",
    "locationCode": "场所代码",
    "basisRemark": "依据/备注",
    "releaseContent": "搬出内容",
    "advanceNotice": "事前提示",
    "close": "关闭",
    "missingQueryNo": "该订单暂无快递单号或 LCL 提单号，无法查询清关信息"
  },
  "email_rcv_yn": {
    "title": "邮件接收"
  },
  "sms_rcv_yn": {
    "title": "短信接收"
  },
  "kakao_rcv_yn": {
    "title": "Kakao 接收"
  },
  "error_msg": {
    "re_log": "无权限，请重新登录。",
    "server": "无法连接服务器。",
    "req": "请求失败。",
    "select_product": "请选择要退货的商品。仅可选择入库异常的商品。如需退回正常商品，请联系管理员。",
    "ignore_error": "请选择要废弃的的商品。",
    "personCtmsNo_required": "请输入通关号",
    "businessNo_required": "请输入企业编号。",
    "duplicate_sku": "已存在，不能重复添加"
  },
  "delivery_title": {
    "delivery": "转运",
    "buy": "代买",
    "msg": "※ 使用橙火订单时，韩国服务费用需自动结算以免延误出库，所以需保证账户余额大于20,000韩元。"
  },
  "loading": {
    "search": "搜索中..."
  },
  "way": {
    "title": "汇款截止时间",
    "ship": "海运",
    "plane": "空运",
    "lcl": "拼箱"
  },
  "kakao": {
    "title": "KakaoTalk 实时咨询",
    "kakao_rcv_yn": "Kakao"
  },
  "date": {
    "title": "日程安排",
    "mon": "一",
    "tue": "二",
    "wed": "三",
    "thu": "四",
    "fri": "五",
    "sat": "六",
    "sun": "日"
  },
  "mny": {
    "title": "汇率信息",
    "exg_rt": "代买汇率",
    "appl_exg_rt": "公告汇率",
    "tt": "TT 汇款汇率",
    "sbj": "适用期间"
  },
  "bank_column": {
    "title": "汇款账户信息",
    "acc_holder": "开户人",
    "msg1": "如果订单人和汇款人姓名不一致，将无法确认。",
    "msg2": "请确认订单人与汇款人一致后再汇款。",
    "sbj": "适用期间"
  },
  "customer_center": "客户服务中心",
  "recommended_cn_shop": "推荐中国购物平台",
  "footer": {
    "terms_of_use": "使用条款",
    "privacy_policy": "隐私政策",
    "site_map": "网站地图",
    "email": "邮箱",

    "address_kr": "韩国地址:인천광역시 서해구 북항로177번길 96 C동",
    "address_cn": "中国地址:山东省青岛市城阳区礼阳路102号  ",

    "business_number": "营业执照号",
    "partnership": "合作咨询"
  },
  "top_banner": {
    "promo": "行业首创，代购手续费 0%",
    "promo_prefix": "行业首创 · 代购手续费",
    "msg": "当其他转运仓库月出货数量达到50件以上时，将升级为高级会员。",
    "solution": "跨境物流 NO.1 解决方案 · 合作伙伴申请",
    "solution_prefix": "跨境物流 ",
    "solution_highlight": "NO.1",
    "solution_suffix": " 解决方案 · 合作伙伴申请"
  },
  "feedback": {
    "category_placeholder": "请选择",
    "entry_title": "错误报告&改善提议",
    "submit_prefix": "提交：",
    "title": "标题",
    "title_placeholder": "请输入标题（最多100字）",
    "content": "内容",
    "content_placeholder": "请详细描述问题或您的建议...",
    "attachments": "图片附件（可选）",
    "upload_image": "点击上传图片",
    "upload_tip": "支持 JPG、PNG、GIF、WEBP 等图片格式，单张不超过10MB，最多9张",
    "submit": "提交",
    "title_required": "请输入标题",
    "title_limit": "标题不能超过100字",
    "content_required": "请输入内容",
    "content_limit": "内容不能超过2000字",
    "image_only": "只能上传图片文件",
    "image_size_limit": "单张图片不能超过10MB",
    "image_count_limit": "最多上传9张图片",
    "uploading": "附件正在上传，请稍候",
    "upload_failed": "图片上传失败，请重试",
    "submit_failed": "提交失败，请重试",
    "success_title": "提交成功",
    "success_message": "我们会尽快处理您的反馈，您可以在“我的反馈”中查看处理进度。感谢您的支持！",
    "list": {
      "entry": "查看我的反馈",
      "title": "我的反馈",
      "description": "查看您提交的错误报告、改善提议及处理进度",
      "title_search": "请输入标题",
      "type": "类型",
      "status": "状态",
      "all": "全部",
      "id": "ID",
      "submitted_at": "提交时间",
      "actions": "操作",
      "view": "查看",
      "error_report": "错误报告",
      "improvement_proposal": "改善提议",
      "pending_reply": "待回复",
      "processing": "处理中",
      "replied": "已回复",
      "total": "共 {total} 条",
      "detail_title": "反馈详情",
      "reply_history": "回复记录",
      "no_reply": "暂无回复",
      "customer_service": "客服",
      "load_failed": "反馈列表加载失败",
      "detail_failed": "反馈详情加载失败",
      "delete_confirm": "确定删除反馈“{title}”吗？",
      "delete_success": "删除成功",
      "delete_failed": "删除失败"
    },
    "categories": {
      "functional_error": "功能错误",
      "display_error": "页面显示异常",
      "order_problem": "订单处理问题",
      "payment_refund_problem": "支付及退款问题",
      "data_error": "数据异常",
      "functional_improvement": "功能改善建议",
      "new_feature": "新功能建议",
      "usability_improvement": "操作体验改善",
      "other": "其他问题"
    }
  },
  "select": {
    "placeholder": "选择",
    "language_kr": "韩语",
    "language_zh": "中文",
    "delivery_method": "运输方式",
    "application_type": "申请类型",
    "order_status": "= 订单状态",
    "shipment_type": "= 出货类型",
    "customs_item": "= 请选择通关品类",
    "payment_status": "支付状态",
    "payment_number": "支付编号",
    "order_number": "订单号",
    "bill_number": "账单编号",
    "refund_bill_number": "退款账单",
    "bill_type": "账单类型",

    "service_type": "服务类型"
  },
  "datepicker": {
    "start": "开始",
    "end": "结束",
    "last_week": "最近一周",
    "last_month": "最近一月",
    "last_3_months": "最近三个月"
  },
  "buyPreOrders": {
    "title": "代买订单号"
  },
  "changeOrders": {
    "title": "原订单号"
  },
  "frmSearch": {
    "sOrderNo": "订单编号",
    "sOrderType": "订单类型",
    "sTrkNo": "快递单号",
    "sConsNmKr": "收货人姓名",
    "sProNm": "商品名称",
    "sProNo": "商品编号",
    "sIvcNo": "出库运单号",
    "STOCK_NO": "库存编号",
    "sMarketBarCode": "商品条码编号",
    "sMarketOptionId": "商品选项ID",
    "sChargeDetCd": "= 发票类型",
    "sIssueDvsCd": "= 发票区分",
    "payCost": "支付费用",
    "deposit_Use": "使用预存款",
    "USE_POINT": "使用优惠券金额",
    "SEND_CENTER_NM": "发货中心",
    "QTY_COST": "总数量/价格",
    "UP_DATE": "日期",
    "DLVR_WAY_SEND_CENTER_NM": "中心/运输方式",
    "TRK_WARE_CNT": "运单数/入库数",
    "yesterday_storage_fee": "前一天保管费(₩)",
    "in_date": "入库日期",
    "out_date": "出库日期",
    "single_wt": "单品重量KG",
    "single_size": "单品规格",
    "single_vol": "单品体积CBM",
    "totle_vol": "总体积",
    "product_type": "商品类型",
    "rack_nos": "货架号",
    "in_out_details": "入库/出库详情",
    "in_details_title": "入库详情",
    "out_details_title": "出库详情"
  },
  "rocket": {
    "header": "橙火入仓 物流中心信息"
  },
  "header_menu": {
    "china_purchased": "中国购入",
    "kr_warehouse_storage": "韩国仓库保管",
    "sea_air_dlv": "海运/航空",
    "coupang_warehouse": "coupang仓库",
    "stock_storage": "库存保管",
    "delivery_truck": "快递货车"
  },
  "info": {
    "dpst": "预存款",
    "nodata": "无数据",
    "unpay": "未支付",
    "note": "留言"
  },
  "request_type": {
    "direct_prchase": "海外直购",
    "express_pickup": "官方揽收快递",
    "collection_pallet": "官方揽收托盘",
    "general_express_delivery": "普通快递",
    "rocket_official_cabinet": "火箭官方整柜",
    "kr": "韩国3PL",
    "cn": "中国3PL",
    "kr_code": "韩国",
    "cn_code": "中国",
    "kr_stock_out": "韩国库存出库",
    "sample": "样品"
  },
  "menu": {
    "direct_purchase": "海外直购",
    "ecommerce_order": "电商快递下单",
    "guide": "使用指南",
    "guide_order": "下单指南",
    "pricing_info": "费用说明",
    "freight_prediction": "运费预测",
    "delivery_service": "转运服务",
    "delivery_service_order": "转运服务下单",
    "delivery_service_excel": "转运服务批量下单",
    "delivery_service_desc_1": "包裹转运至全球各地",
    "delivery_service_desc_2": "多种渠道可选，安全高效",
    "delivery_request": "转运申请",
    "bulk_excel_upload": "批量Excel上传",
    "inventory_request": "库存申请",
    "buying_service": "代买服务",
    "buying_service_order": "代买服务下单",
    "buying_service_excel": "代买服务批量下单",
    "buying_service_desc_1": "专业代买团队帮您采购商品",
    "buying_service_desc_2": "支持多平台代购",
    "ocean_logistics_order": "海运物流下单",
    "buying_request": "代买申请",
    "product_management": "已注册商品管理",
    "product_excel_upload": "批量注册商品",
    "rocket_service": "橙火入仓服务",
    "rocket_delivery_request": "转运申请",
    "inbound_request": "入库申请",
    "rocket_buying_request": "代买申请",
    "customer_service": "服务中心",
    "notice": "公告",
    "notice_3pl": "3PL公告",
    "faq": "常见问题",
    "user_reviews": "用户评价",
    "lost_and_found": "无会员号包裹",
    "no_data": "无数据管理",
    "return_no_data": "返送无数据包裹",
    "address_management": "收货地址管理",
    "customs_schedule": "查询通关日程",
    "my_page": "个人中心",
    "member_info": "会员资料",
    "order_status": "订单列表",
    "order_detail": "订单详情",
    "payment_management": "支付管理",
    "deposit_krw": "韩元预存款申请",
    "deposit_cny": "人民币预存款申请",
    "coupon_list": "优惠券管理",
    "notification_messages": "通知消息",
    "edit_profile": "会员信息",
    "product_main": "商品管理",
    "order_main": "订单管理",
    "china_inventory": "中国库存",
    "korea_inventory_buy_order": "代买下单",
    "korea_inventory_transfer_order": "转运&库存下单",
    "china_inventory_upload": "转运下单",
    "buy_cn_inventory": "代买下单",
    "buy_cn_delivery": "中国购入下单",
    "buy_kr_delivery": "韩国购入下单",
    "korea_inventory_cn": "中国购入韩国库存",
    "korea_inventory": "韩国库存",
    "buy_cn": "中国购入",
    "buy_kr": "韩国购入",
    "rocket_china": "中国",
    "rocket_korea": "韩国",
    "inbound_kr": "韩国入库",
    "korea_inventory_shipping": "韩国库存发货",
    "send_way": "快递/货车",
    "service_application": "服务申请",
    "point_management": "积分管理",
    "account_management": "账号管理",
    "cn_3pl_inbound": "中国3PL入库",
    "kr_3pl_inbound": "韩国3PL入库",
    "kr_3pl_outbound": "韩国3PL出库",
    "cn_3pl_inbound_desc": "货物在中国仓集货",
    "kr_3pl_inbound_desc": "货物进入韩国仓",
    "kr_3pl_outbound_desc": "从韩国仓发给买家",
    "buy_cn_inventory_desc": "平台代购后入中国仓",
    "china_inventory_upload_desc": "自购商品寄到中国仓",
    "inventory_dropshipping_kr": "库存一件代发",
    "inventory_dropshipping_kr_order": "韩国库存出库下单",
    "inventory_dropshipping_kr_excel": "韩国库存出库批量下单",
    "inventory_batch_outbound": "库存批量出库",
    "inventory_batch_outbound_order": "库存批量下单",
    "inventory_batch_outbound_statistics": "库存出库统计",
    "cooperation_management": "合作管理"
  },
  "coupon_yn": {
    "coupon_y": "可用",
    "coupon_n": "不可用"
  },
  "stock_manage": {
    "registered_label": "注册",
    "today_fee_tip": "该金额为实时预估数据，仓储费账单在每日24点后生成。",
    "expiry_managed": "有效期管理",
    "no_expiry": "无有效期",
    "unit_item": "件",
    "unit_sku": "个",
    "unit_bill": "笔",
    "fee_detail": "费用明细",
    "no_unpaid": "暂无待支付",
    "select_all": "全选",
    "selected": "已选 {n} 项"
  },
  "combined_builder": {
    "delete_item_confirm": "确定从该套装中删除此商品规格吗？",
    "delete_package": "删除套装",
    "delete_selected": "批量删除（{count}）",
    "select_all": "选择套餐内全部商品",
    "select_item": "选择商品",
    "delete_selected_confirm": "确定删除{name}中选中的 {count} 个规格吗？",
    "select_product_customs": "请选择清关代码。",
    "fill_product_english_name": "请填写「{name}」的商品英文名。",
    "composition_count": "{count} 种规格 / {quantity} 件",
    "invalid_price": "商品单价必须大于 0，请检查后再添加。",
    "delete_package_confirm": "确定删除{name}及其中的所有规格吗？",
    "fill_required_fields": "请填写所有套餐的必填信息",
    "fetch_product": "获取商品",
    "collapse": "收起",
    "expand": "展开",
    "added": "已加入",
    "items_across_packages": "项（跨套餐）",
    "customs_complete": "清关已填写",
    "customs_pending": "清关信息待完善",
    "stock": "库存",
    "action": "操作",
    "out_of_stock": "无库存",
    "added_to_current_package": "已添加到当前套餐",
    "add_to_prefix": "添加到",
    "add_to_current_package": "添加到当前套餐",
    "quantity_stock_hint": "数量为 0 时按 1 件添加；红色数字为库存。",
    "drag_or_add_hint": "拖动左侧规格行到套餐，或点击加号添加",
    "drop_to_add": "松开即可加入此套餐",
    "current_package": "当前套餐",
    "click_to_select": "点击选择",
    "empty_package_hint": "将左侧商品规格拖到这里，或点击规格旁的加号",
    "stock_limit_reached": "已达到该规格库存上限",
    "stock_limit": "库存上限",
    "product_link": "商品链接",
    "product_attributes": "商品属性",
    "already_in_package": "该规格已在当前套餐中",
    "product_already_fetched": "该商品已获取，请在原商品中选择规格",
    "fetch_product_failed": "商品信息获取失败，请检查链接后重试",
    "source_missing": "商品来源信息缺失，请重新添加该规格",
    "registration_success": "注册成功",
    "registration_uncertain": "未能确认注册结果，请先查看商品列表，确认未注册后再重试。",
    "batch_result": "已添加 {added} 项，已存在 {existing} 项，无库存跳过 {outOfStock} 项（{packageName}）",
    "select_field": "请选择{label}"
  },
  "pro_manage": {
    "edit_barcode_info": "修改条码",
    "edit_basic_info": "修改信息",
    "simple_mode": "商品模式",
    "view_mode": "显示模式",
    "list_mode": "列表模式",
    "grid_mode": "宫格模式",
    "option_details": "选项 / 条码 / 选项 ID",
    "package_details": "重量 / 包装 / CBM",
    "created_label": "注册",
    "updated_label": "修改",
    "title": "条码商品名/商品编号/sku编号/条形码编号",
    "notice": "注意事项：只可以删除没有库存的商品",
    "msg_del": "请先选择商品或SKU",
    "msg_confirm_del": "确定删除已选中的商品吗？",
    "msg_confirm_delist": "确定要下架吗？",
    "msg_confirm_restore": "确定要上架商品吗？",
    "msg_delist": "请先选择要下架的商品或SKU",
    "packing": "包装规格",
    "combined_quantity": "合单数量",
    "regi_modify_date": "登录/修改日",
    "single_add": "添加单一商品",
    "combine_add": "添加合单商品",
    "single_product": "单一商品",
    "combined_product": "合包商品",
    "sku_edit_title": "修改商品SKU信息",
    "pro_edit_title": "修改构成商品信息",
    "composition_title": "构成商品信息",
    "barcode_title": "条形码信息",
    "barcode_number": "条形码编号",
    "barcode_same_as_sku_tip": "如果平台商品条码编号与 SKU CODE 相同，不可编辑，请输入其他条码。",
    "product_registration": "商品注册",
    "coupang_sku_code": "酷彭",
    "same_platform_sku_id": "同{platform}一样的 SKU ID",
    "coupang_sku_code_tip": "平台商品注册时，系统 SKU Code 与 平台 SKU Code 保持一致，可节省标签打印费用。",
    "sku_list": "SKU列表",
    "exist_msg": "该 SKU 已添加过",
    "sku_none": "暂无可添加的 SKU",
    "sku_end": "没有新的 SKU 被添加",
    "sku_success": "成功添加",
    "missing_coupang_barcode": "当前 SKU 未上传酷澎条码，请在商品管理页面补充条码信息后重试下单。",
    "sku_add_msg": "请先添加SKU",
    "market_pro_nm": "条形码商品名称",
    "no_sku_msg": "暂无套装，请添加商品。",
    "set_price": "套餐单价",
    "package": "套餐",
    "sku_group_required": "第 {index} 个 SKU 组缺少必填信息",
    "delete_success": "删除成功",
    "package_not_selected": "请先添加一个套餐",
    "new_package_created": "新的套餐已成功创建",
    "packaging_request": "包装作业请求",
    "dlvry_warehouse": "配送仓库",
    "packing_title": "包装信息",
    "inventory_details": "入库明细",
    "out_details": "出库明细",
    "stock_details": "库存明细",
    "declaration_fee": "保管费",
    "down_stock_details": "下载库存明细",
    "all_confirm": "批量确认",
    "all_cancel": "批量取消",
    "delist_product": "下架",
    "all_delist_product": "全部下架",
    "all_list_product": "全部上架",
    "list_product": "上架",
    "view_delisted_product": "查看下架商品",
    "view_product_manage": "查看商品管理",
    "barcode_edit": "条码编辑",
    "barcode_type": "条码类型",
    "same_or_different": "同种/异种",
    "same_kind": "同种",
    "different_kind": "异种",
    "duplicate_barcode_type_tip": "该条码类型已经选择过，请选择其他条码类型。",
    "barcode_upload_msg": "条码编辑图片已上传成功",
    "outbound_quantity": "已出库数量"
  },
  "pro_manage_new": {
    "stat_total": "全部商品",
    "stat_page_products": "本页商品",
    "stat_page_options": "本页选项",
    "stat_spec_missing": "未填规格（本页）",
    "unit_count": "个",
    "unit_option": "个选项",
    "col_product": "商品",
    "col_option": "选项 / 条码",
    "col_price": "单价",
    "col_weight": "重量",
    "col_qty": "组合数",
    "col_flags": "标识项",
    "col_status": "状态",
    "col_updated": "修改日期",
    "flag_origin": "原产地",
    "flag_age": "14岁以下",
    "flag_expiry": "保质期",
    "option_count": "{n}个选项",
    "component_count": "{n}个组成商品",
    "confirm_download": "确定要下载商品数据（Excel）吗？",
    "selected": "已选 {n} 个",
    "clear_selection": "取消选择",
    "product_count": "{n}个商品",
    "foot": "共 {total} 个 · 每页 {size} 个"
  },
  "excel": {
    "excel_sample": "批量下单模板下载",
    "excel_bulk_resgiter": "批量上传导入",
    "bulk_res_download": "Excel批量上传模板下载",
    "customs_clearance_list_download": "通关品类列表下载",
    "additional_service_download": "附加服务下载",
    "logistics_center_download": "物流中心列表下载",
    "tips_msg": "请下载批量注册Excel样本，填写后进行注册。",
    "tips_co_title": "品类最终更新日期",
    "tips_co_msg": "[用于C/O发放相关] 项目新增",
    "file_search_button": "选择文件",
    "file_size": "文件最大大小：10 MB",
    "tips_center_msg": "例如) 使用光州4(GWJ4)物流中心时请填写代码GWJ4",
    "tips_reg_msg": "请下载批量注册商品Excel样本，填写后进行注册。",
    "please_select_file": "请选择Excel文件",
    "email_result": "邮编为5位数",
    "address_result": "地址需填写街道名",
    "submit_failed": "提交失败",
    "no_preview_data": "没有可验证的数据",
    "no_valid_verification_data": "没有有效的验证数据",
    "customs_code_verified": "个人通关号验证通过",
    "verification_failed": "验证失败",
    "customs_code_verification_failed_title": "存在验证失败的个人通关号",
    "customs_item_number_required": "请输入通关物品编号之后再提交订单。"
  },
  "stock": {
    "logistics_Center": "选择物流中心",
    "red_tips": "商品信息 * 红色边框为必填项",
    "no_data": "无库存商品。"
  },
  "BUSI_DVS_CD": {
    "person": "个人",
    "Business": "企业",
    "Foreigner": "vip用户"
  },
  "allPackItemways": {
    "express_pack": "快递袋包装",
    "box_pack": "纸箱包装",
    "original_pack": "产品原包装"
  },
  "delivery_fee_rule": {
    "billing_value": "计费重量/体积",
    "billing_range": "计费范围",
    "starting_fee": "起步金额",
    "billing_step": "计费步长",
    "step_increment": "每步增加",
    "dimension_range": "三边合范围",
    "weight_range": "重量范围",
    "no_rule": "暂无运费规则",
    "more": "查看更多"
  },
  "dlvr_calcuation": {
    "item_seq": "请选择项目",
    "total_mny": "请输入商品总金额",
    "select_weight": "请选择重量",
    "title": "运费预算",
    "user_level": "会员等级",
    "dlvry_cd": "集运仓",
    "warehouse": "集运仓库",
    "transport_method": "运输方式",
    "transport_type": "运输类型",
    "item_title": "通关代码确认",
    "mny_title": "物品总金额",
    "wt_title": "重量",
    "exg_title": "转换汇率",
    "service": "其他附加费",
    "shipping": "运费",
    "shipping_fee": "费用",
    "order_fee": "其他附加费",
    "total_amout": "总金额",
    "purchase_cost": "采购总费用",
    "purchase_mny": "采购费",
    "apply_category": "申请类别",
    "purchase_fee": " 采购手续费",
    "pruchase_titme": "采购报价时间",
    "cargo_information": "货物信息",
    "add_box_size": "新增箱子尺寸",
    "box_size": "尺寸",
    "box_numbers": "箱子数量（个）",
    "rules_title": "运费计算基于以下计费规则",
    "rules_vol_ways": "体积重量计算方法",
    "vol_ways_info": "物品体积与实际磅重取大计费，测量体积以最高点测量的方式：长 × 宽 × 高 / 体积系数 = 重量",
    "calculation_unit": "计算单位",
    "calculation_kg": "在测量重量时，每向上 0.5kg 取整，即：当物品重量在 5.35kg 时，实际计费按照 5.5kg。",
    "calculation_cbm": "测算体积时，每向上 0.1CBM 取整，即：当物品体积在 1.12CBM 时，实际计费按照 1.2CBM。",
    "calculation_charge_weight": "计费重量",
    "calculation_real_weight": "实际重量",
    "cancel_fee": "取消手续费用",
    "delivery_fee": "配送费用",
    "refund_fee": "退款费用",
    "return_fee": "退货费用",
    "discard_fee": "废弃费用",
    "calculator_title": "跨境物流运费计算器",
    "calculator_subtitle": "快速计算物流运费，支持多种运输方式",
    "freight_tab": "运费计算",
    "additional_tab": "附加服务",
    "basic_info": "基本信息",
    "estimate_title": "费用估算",
    "weight_label": "重量（kg）",
    "weight_placeholder": "请输入重量",
    "weight_hint": "首重{start}kg，续重每{step}kg计费",
    "volume_label": "体积（CBM）",
    "volume_placeholder": "请输入体积",
    "volume_hint": "每0.1CBM为一个计费单位",
    "box_count": "箱数（可选）",
    "box_placeholder": "不填写则按体积÷0.1计算",
    "box_hint": "若不填，按每0.1CBM计算箱数",
    "pallet_count": "托盘数（可选）",
    "pallet_placeholder": "不填写则按体积÷1.8计算",
    "pallet_hint": "若不填，按方数÷1.8并向上取整计算托盘数",
    "enter_measurement": "请输入重量或体积开始计算",
    "no_matching_rule": "当前会员等级暂无对应计费规则",
    "over_rule_range": "输入值超出当前计费规则范围",
    "select_grade_rule": "请选择有计费规则的会员等级",
    "actual_weight": "重量",
    "freight_total": "运费",
    "first_weight_fee": "首重费用（{value}kg）",
    "additional_weight_fee": "续重费用（{count}×{step}kg）",
    "freight_subtotal": "运费小计",
    "company_customs_fee": "企业清关费用",
    "actual_volume": "实际体积",
    "calculated_boxes": "计费箱数",
    "calculated_pallets": "托盘数量",
    "box_unit": "箱",
    "pallet_unit": "托",
    "billing_volume": "计费体积",
    "volume_freight": "运费（{count}×{step}CBM）",
    "document_fee": "换单费＋文件操作费",
    "terminal_fee": "码头操作费",
    "bonded_pickup_fee": "保税仓提货费",
    "korea_box_fee": "韩国费用（{count}箱）",
    "bonded_pallet_fee": "保税仓提货费（{count}托）",
    "packing_fee": "包装费用（{count}托）",
    "korea_pallet_fee": "韩国费用（{count}托）",
    "input_mode": "输入模式",
    "simple_mode": "简单模式",
    "simple_mode_hint": "直接填写总体积",
    "detail_mode": "详细模式",
    "detail_mode_hint": "填写商品尺寸自动计算",
    "auto_calculated": "自动计算",
    "auto_volume_hint": "根据所有商品的尺寸和数量自动计算",
    "product_list": "商品列表",
    "optional": "（可选）",
    "product_list_hint": "如需计算附加服务费用（条形码、产地标、包装等），请添加商品",
    "detail_product_list_hint": "填写商品数量和尺寸，自动计算体积及附加服务费用",
    "empty_products": "暂无商品，如需计算附加服务费用，请添加商品",
    "empty_detail_products": "请添加商品以计算体积和附加服务费用",
    "product_number": "商品 #{number}",
    "product_quantity": "商品数量",
    "product_length": "长（cm）",
    "product_width": "宽（cm）",
    "product_height": "高（cm）",
    "three_side_sum": "三边和（cm）",
    "size_fee_hint": "用于计算包装和OPP袋费用",
    "product_weight": "重量（kg）",
    "barcode_service": "代贴条形码（₩100/个）",
    "origin_label_service": "产地标作业",
    "origin_none": "不需要",
    "origin_sticker": "粘贴产地贴纸（₩50/个）",
    "origin_tag": "挂产地吊牌（₩200/个）",
    "origin_sewn": "缝制产地标（₩300/个）",
    "set_packaging": "套装包装",
    "set_product_count": "套装内商品数",
    "set_product_hint": "第一个按原价，其他按80%",
    "opp_bag_service": "使用OPP袋",
    "add_product": "添加商品",
    "base_fee_total": "基础运费合计",
    "additional_fee_total": "附加服务费用合计",
    "barcode_fee": "代贴条形码费用",
    "origin_label_fee": "产地标作业费用",
    "set_packaging_fee": "套装包装费用",
    "opp_bag_fee": "OPP袋费用",
    "estimate_notice": "以上费用仅供参考，实际费用以物流服务商报价为准",
    "tax_notice": "金额单位为韩元（₩）"
  },
  "ctms": {
    "placeholder": "请选择正确的品名。（用于海关申报）"
  },
  "apply_wt_info": {
    "title": "重量信息"
  },
  "apply_wt": {
    "title": "适用重量"
  },
  "total_real_wt": {
    "title": "重量"
  },
  "conv_weight_kg": {
    "title": "体积重量"
  },
  "CHARGE_WEIGHT": {
    "title": "体积"
  },
  "TOT_COST": {
    "title": "总支付费用"
  },
  "MARK_NO": {
    "title": "标记编号"
  },
  "PALLET_MARK_NO": {
    "title": "托盘标记编号"
  },
  "IVC_ADD_INF": {
    "title": "京东快递"
  },
  "PACKING_ORDER_YN": {
    "title": "包装状态"
  },
  "WT_KG": {
    "title": "重量"
  },
  "VOL_WH": {
    "title": "宽度"
  },
  "VOL_LH": {
    "title": "长度"
  },
  "VOL_HT": {
    "title": "高度"
  },
  "POST_NO": {
    "title": "会员编号",
    "name": "会员名称"
  },
  "DPST": {
    "title": "预存款(￦)",
    "manage_title": "预存款管理",
    "pay_title": "预存款支付",
    "transfer_title": "转账支付",
    "credit_card_title": "信用卡支付"
  },
  "POINT": {
    "title": "积分",
    "change_reason": "使用区分",
    "point_amount": "积分变动",
    "point_principal": "可用积分",
    "point_remark": "内容",
    "point_use_tip": "只有国际配送费用才可以使用"
  },
  "COMPENSATION_DEPOSIT": {
    "title": "赔偿预存款管理",
    "short_title": "赔偿预存款",
    "change_reason": "使用区分",
    "change_amount": "赔偿预存款变动",
    "available_amount": "可用赔偿预存款",
    "deduction": "赔偿预存款抵扣",
    "payment_placeholder": "请输入赔偿预存款金额",
    "use_all": "使用全部赔偿预存款",
    "unsupported_bill": "所选账单不支持使用赔偿预存款支付",
    "unsupported_order": "所选订单不支持使用赔偿预存款支付",
    "remark": "内容",
    "date": "日期"
  },
  "payment_list_header": {
    "coupon_deduction": "代金券抵扣",
    "point_deduction": "积分抵扣",
    "compensation_deduction": "赔偿预存款抵扣",
    "amount": "金额",
    "china_use": "（中国用）",
    "korea_use": "（韩国用）"
  },
  "warehouse_popup": {
    "entry": "仓库",
    "title": "集运仓地址",
    "copy_address": "复制地址",
    "copy_full_address": "复制完整地址",
    "recipient_info": "收件信息",
    "member_code": "会员编号",
    "postal_code": "邮政编码",
    "province": "省（省份）",
    "city": "市（城市）",
    "phone": "联系电话",
    "recipient": "收件人",
    "no_data": "暂无可用仓库信息",
    "copy_failed": "复制失败，请手动复制"
  },
  "coupon_qt": {
    "title": "优惠券",
    "msg": "若要使用优惠券，请选择预存款自动支付。",
    "coupon_list": "优惠券列表",
    "already_used": "该优惠券已用于其它账单",
    "discount_amount": "代金券抵扣金额",
    "point_amount": "积分抵扣金额"
  },
  "unpaid_qt": {
    "title": "未支付"
  },
  "icon": {
    "shopping": "代买",
    "truck": "转运",
    "logout": "入/出库",
    "truk1": "退货管理",
    "error": "错误",
    "refresh": "库存管理",
    "package": "橙火入仓",
    "stock": "库存"
  },
  "개": "个",
  "SUB_IVC_NO": {
    "title": "CJ大韩通运"
  },
  "PAYMENT_WAY_CD": {
    "bank": "无纸化存款",
    "CreditCard": "信用卡",
    "title": "存款账户"
  },
  "tab_title": {
    "deposit_req": "预存款充值",
    "compensation_deposit_management": "赔偿预存款管理",
    "payment settlement": "账单结算",
    "paymentW": "待支付账单",
    "paymentWChina": "中国待支付账单",
    "paymentWKorea": "韩国待支付账单",
    "paymentL": "已支付账单",
    "DepositReq_1": "充值申请",
    "DepositReq_2": "退款申请",
    "DepositReq_3": "预存款明细",
    "coupon": "可用优惠券",
    "couponUsed": "优惠券使用记录",
    "sms": "手机查找",
    "email": "通过邮箱查找",
    "dialog": "设置新密码",
    "phone": "电话号码",
    "code": "验证码",
    "Order_Divide": "产品列表",
    "Order_Bundle": "订单列表"
  },
  "tips": {
    "msg1": "如果需要一次支付多项，请全部点击对应项。",
    "msg2": "对于待支付订单，所有包装及运费已计算完成，无法进行重新包装或合并/拼单配送。",
    "msg3": "※ 使用信用卡支付时，2.6%手续费由客户承担。",
    "msg4": "KB国民银行201301-04-460220  (李哲洪",
    "msg5": "充值只支持无纸化存款，申请后将在1日内确认并充值。",
    "msg6": "申请【中国发票】的会员无法申请【韩元充值】。",
    "msg7": "*充值只支持无纸化存款，申请后将在1日内确认并充值。",
    "msg8": "申请人民币充值后汇款，将为您兑换韩元。[人民币存入金额 x 汇率 = 韩元充值金额]",
    "msg9": "请扫描下方二维码，将人民币充值金额汇入。",
    "msg10": "存款时请务必填写邮箱号，否则无法确认存款。",
    "msg11": "邮箱号填写方法请参考《使用指南 > 充值申请指南》。",
    "delMsg": "请选择要删除的信息。",
    "markMsg": "请选择便签。",
    "SMS_RCV_YN": "通知消息：可持续获取状态更新（报价、入库、出库、配送、错误）",
    "perOrBus": "个人-韩元充值（个人/企业切换及企业信息变更请通过KakaoTalk申请）",
    "LOGOUT_M1": "注销会员后，第一次无法登录，第二次由管理员",
    "LOGOUT_M2": "确认后最终注销。",
    "LOGOUT_M3": "最终注销后，注册的个人信息将被删除。",
    "LOGOUT_M4": "最终注销前可联系管理员取消注销。",
    "POST_NO_msg": "不允许特殊字符的地方请去掉#号后再注册。",
    "COYP_SUCCESS": "复制成功",
    "COPY_ERR": "复制失败",
    "ADDR_MSG": "请输入街道为了顺利清关，请使用正确的街道地址",
    "REQ_SEL": "请留下要通知国内配送员的要求（如：不在时请手机联系）",
    "ORDERS_MSG": "请选择要申请接收的订单。",
    "COUPON_TIP": "请使用附加服务修改进行优惠券注册。",
    "itemCont": "该订单只有一件商品时，仅可删除订单（若只剩子追踪号则不可删除）",
    "PRO_RES": "红色边框为必填项",
    "TRK_CONT": "如没有快递单号，后续请在个人中心-全部订单中填写",
    "STOCK_CONT": "库存商品变更除数量外信息时，仍以库存申请商品信息为准。",
    "item_seq": "清关代码搜索",
    "PRO_NM_EN_CONT": "请准确填写以避免清关延误。（禁止输入特殊字符及韩文）",
    "PRO_AMT_CONT": "请输入商品总支付金额。",
    "addr_det": "请输入街道为了顺利清关，请使用正确的街道地址",
    "rokect_addr_det": "申请橙火头程时，默认填写CHINAONE韩国仓库地址。",
    "TOTAL_PRO_COST_M1": "为向海关申报金额（与商城支付金额相同）",
    "TOTAL_PRO_COST_M2": "总金额若超过150美元，需收取通关手续费。",
    "TOTAL_PRO_COST_M3": "食品、液体、粉末等不可目录通关商品将进行简易通关。（海关查获责任自负，请注意）",
    "ERR_TIPS": "申请接收后不可修改。若需添加追踪号等修改，请选择申请待定。",
    "ERR_TIPS_BR": "(申请完成后若因特殊原因需修改请求书，请联系客服1:1咨询)",
    "SELECT_TIPS": "ChinaOne的合单与单独配送无论哪种，均通过同一申请单完成配送申请。",
    "CHECKBOX_TIPS": "请确认完整阅读并同意以上条款。",
    "CHECKBOX_TIPS_red": "必选",
    "ServerAgree": "需同意服务申请注意事项条款。",
    "DLVR_WAY": "请选择运输方式。",
    "WAREHOUSE_INVALID": "仓库信息已失效，请返回上一步重新选择集运仓库后再下单。",
    "tamall": "请输入商品地址",
    "ctms_tips": "请选择清关代码",
    "Skus_tips": "请选择商品数量",
    "Stock_tips": "请输入数量",
    "GetUrl_tips": "请输入商品URL",
    "payment": "预存金额不能超过支付金额",
    "DIVIDE": "请选择要分拆处理的商品。",
    "BUNDLE": "请选择订单编号。",
    "reg_del": "确定删除所选注册商品吗？",
    "buy_tips": "申请采购报价后，报价完成将无法修改。",
    "buy_tips_br": "(报价完成后若因特殊原因需修改请求书，请联系客服1:1咨询)",
    "return_payment_tip": "※ 韩国仓库返送处理费用仅支持使用预存款自动支付，且预存款余额须达到20万韩元以上方可申请。",
    "return_edit_tip": "提交申请后，如因特殊原因需要修改申请内容，请通过1:1咨询联系我们。"
  },
  "placeholder": {
    "USE_DPST": "费用结算",
    "USE_POINT": "使用积分",
    "PAYIN_NM": "汇款人姓名",
    "LOGOUT": "请输入当前密码",
    "explame": "ex) 판교역로235,제주 첨단로 242",
    "TRK_NO": "输入快递单号",
    "SHOP_ORDER_NO": "填写采购订单号",
    "PRO_NM_EN": "商品英文名",
    "pro_code": "商品代码",
    "taobao_url": "输入商品URL"
  },
  "saveTrackingNumber": {
    "TRK_NO": "请输入追踪号码。"
  },
  "SubTrk": {
    "TRK_NO": "请输入Tracking No。"
  },
  "TRK_NO": {
    "msg": "请输入追踪号码。"
  },
  "dvCardFee": {
    "title": "信用卡手续费"
  },
  "CouponMny": {
    "title": "优惠券折扣",
    "coupon_use": "使用优惠券",
    "coupon_msg": "折扣后支付金额"
  },
  "frmDpstRet": {
    "MNY": "退款金额"
  },
  "frmDpst": {
    "MNY": "人民币充值申请金额(￥)"
  },
  "ISSUEDVSCDObj": {
    "one": "会员注册活动",
    "three": "管理员发放",
    "four": "会员升级优惠券发放"
  },
  "CHARGE_DET_CD_obj": {
    "one": "配送费用",
    "nitythree": "处理费"
  },
  "Received": {
    "TITLE": "收到的信息"
  },
  "customs_company": {
    "company_select": "企业选择",
    "select_license": "选择营业执照",
    "current_company": "当前企业信息"
  },
  "formData": {
    "MEM_ID": "账号",
    "POST_NO": "邮箱号",
    "MEM_NM": "姓名",
    "MEM_NM_EN": "英文名",
    "MOB_NO": "手机号",
    "LASEST_LOG": "最后登录",
    "SMS_RCV_YN": "接收同意（必填）",
    "person_Bus": "个人/企业",
    "perOrBusMsg": "切换及企业信息变更请通过KakaoTalk申请。",
    "perOrBusTitle": "企业信息修改方法",
    "bus_info": "企业信息",
    "ChinaNum": "中国企业编号",
    "ChianPartner": "中国企业名称",
    "PERSON_CTMS_NO": "个人通关信息",
    "CONTACTS": "联系方式",
    "DLVR_REQ_CONT": "配送要求",
    "CENTER_REQ_CONT": "中心要求"
  },
  "EIDT_PASSWORD": {
    "title": "密码修改",
    "oldpass": "请输入旧密码",
    "newpass": "请输入新密码",
    "newpass_cf": "请再次输入新密码"
  },
  "newpass": {
    "required": "请使用6~20位英文大小写字母、数字、特殊符号注册"
  },
  "newpass_cf": {
    "required": "请再次输入新密码。"
  },
  "oldpass": {
    "required": "请输入旧密码。"
  },
  "PRO_AMT": {
    "required": "请输入合计（合计至少为1）"
  },
  "COLOR": {
    "required": "请输入颜色。"
  },
  "SIZE": {
    "required": "请输入尺寸。"
  },
  "center_seq": {
    "qd": "青岛",
    "kr": "韩国配送"
  },
  "Recipient": {
    "title": "收件人"
  },
  "return_msg": {
    "title": "退货"
  },
  "return_address_msg": {
    "title": "退货地址"
  },
  "원": "韩元",
  "popup_title": {
    "addr": "收货地址列表",
    "addr_edit": "收件人信息修改",
    "shop_res": "注册产品",
    "precautions": "下单须知",
    "Logistics_sel": "选择集运仓库",
    "vw_DLVR_WAY_CD_sel": "选择运输方式",
    "DLVR_WAY_TITLE": "仓库及物流方式",
    "pro_info_title": "商品信息",
    "ZipSearch": " 道路名地址搜索",
    "shopping": "商品",
    "orderDivide": "分批配送",
    "DivideInfo": "当前订单信息",
    "COST": "费用明细",
    "Order_Bundle": "合并配送",
    "TrkPhotoPop_S": "实景查看",
    "PRE_PRO_NO": "购买商品编号",
    "RocketFile": "Coupang入库信息登记",
    "OrderPhotoPop": "出库实景",
    "stockTitle": "库存商品",
    "regpro_title": "注册商品下单",
    "mny_title": "商品金额信息",
    "must": "是必填字段",
    "individual_pack": "剩余商品单个包装",
    "combined_pack": "组合包装",
    "storage_method_sel": "选择入库方式",
    "storage_method": "入库方式",
    "outbound_method_sel": "选择出库方式",
    "outbound_method_tip": "请选择本次订单的出库方式，并完成下方 Coupang 入库资料及文件上传。",
    "express_outbound_ready": "提交后：快递出库准备",
    "official_outbound_ready": "提交后：官方揽收出库准备",
    "outbound_api_pending": "出库申请提交接口暂未接入"
  },
  "origin_label": {
    "origin_no": "条码上不印原产地",
    "origin_china": "原产地 MADE IN CHINA"
  },
  "CONS_NM_KR": {
    "required": "请输入韩文姓名。",
    "title": "收件人信息",
    "placeholder": "韩文姓名",
    "h5_title": "收件人信息",
    "required_return": "请输入收件人姓名。",
    "company_name_kr": "企业名称(韩文)",
    "company_name_en": "企业名称(英文)",
    "company_ctms_no": "企业清关号",
    "ctms_no": "清关号"
  },
  "CONS_NM_EN": {
    "placeholder": "英文名"
  },
  "CTMS_DVS_CD": {
    "person": "个人通关唯一编号",
    "bussiess": "企业编号",
    "passport": "护照号码"
  },
  "CONS_ADDR": {
    "required": "请输入地址。"
  },
  "CONS_ADDR_DET": {
    "required": "请输入详细地址。"
  },
  "CONS_ZIP": {
    "title": "地址",
    "title_EN": "地址(英文)",
    "title_DET": "详细地址(韩文)",
    "title_DET_EN": "详细地址(英文)",
    "placeholder": "邮政编码",
    "ckBASE_YN": "默认送货地址",
    "CONS_ADDR_DET": "详细地址",
    "required": "请输入邮政编码。"
  },
  "WARE_RESERV_DT": {
    "title": "Coupang取货日",
    "messages": "请选择Coupang取货日。",
    "required": "Coupang取货日必须是今天以后。"
  },
  "OUT_STATE_CD": {
    "title": "出库状态"
  },
  "PACKING_PRO_YN": {
    "title": "包装状态"
  },
  "MARKET_PRO_NM": {
    "title": "入库用商品名",
    "placeholder": "市场商品名",
    "required": "请输入市场商品名。"
  },
  "barcode_info": {
    "title": "商品条码信息",
    "platform_select_title": "平台商品信息选择",
    "selectPlatform": "请选择平台",
    "platformProductInfo": "平台商品信息"
  },
  "MARKET_BARCODE": {
    "title": "商品条码",
    "required": "请输入商品条形码。"
  },

  "MARKET_OPTION_NM": {
    "title": "商品选项名",
    "required": "请输入。",
    "option_name": "选项名"
  },
  "MARKET_OPTION_ID": {
    "title": "商品选项ID",
    "required": "请输入商品条形码。"
  },
  "MARKET_EXPIRY_DT": {
    "title": "有效期限",
    "y": "产品有有效期限",
    "n": "产品无有效期限",
    "required": "该商品设置了有效期，请选择有效期日期"
  },
  "return_address": {
    "title": "退货地址信息",
    "h5_title": "(退货)收件人",
    "address": "(退货)地址",
    "title_3": "退货地址信息"
  },
  "ORIGIN_PRINT_YN": {
    "title": "原产地标识"
  },
  "ORDER_NO_ORGIN": {
    "title": "原订单编号"
  },
  "ROCKET_COM_NM": {
    "title": "Coupang公司名",
    "required": "请输入Coupang公司名。"
  },
  "ReInfo": {
    "title": "预约信息"
  },
  "rokectH": {
    "title": "Rocket Gross物流中心"
  },
  "WARE_RESERV_NO": {
    "title": "Coupang入库请求ID",
    "required": "请输入Coupang入库请求ID。"
  },
  "PERSON_CTMS_NO": {
    "title": "个人通关唯一编号或企业编号或护照号码"
  },
  "req_sel": {
    "title": "配送要求选择",
    "placeholder": "= 请选择"
  },
  "DLVR_REQ_CONT": {
    "title": "配送要求直接填写"
  },
  "DLVR_REQ_CONT_ELSE": {
    "title": "备注信息"
  },
  "order_bundle": {
    "success_msg": "已成功合并处理。",
    "nodata_msg": "没有可合并的订单。",
    "bundle-tips": "请选择需要合并的订单"
  },
  "OPTIONS": {
    "VALUE1": "配送前请联系",
    "VALUE2": "不在时请联系手机",
    "VALUE3": "不在时请交给保安室",
    "VALUE4": "不在时请放在家门口",
    "VALUE5": "请放入快递箱"
  },
  "orgin_options": {
    "single_label": "单独产地标粘贴",
    "set_label": "套装产地标粘贴",
    "tag_work": "产地吊牌作业",
    "sewing_work": "产地缝制作业",
    "stamp_work": "产地印章作业"
  },
  "orgin_title": {
    "title": "产地标作业方式",
    "select": "选择",
    "write": "手动输入",
    "origin_information": "产地证信息",
    "co_pro_en": "英文品名"
  },
  "RocketFileTitle": {
    "title": "物流中心随附文件"
  },
  "statusMap": {
    "order_state": "进行状态",
    "dlv_state": "物流中心",
    "App_Category": "申请分类",
    "PRO_STATE": "商品",
    "SVC_STATE": "自动结算",
    "MANUAL_SETTLEMENT": "手动结算"
  },
  "CONS_NM_INFO": {
    "TITLE": "收件人信息"
  },
  "send_info": {
    "title": "发件人信息"
  },
  "ROCKET_CONS_NM": {
    "TITLE": "收件人",
    "required": "物流中心收件人信息必填"
  },
  "SHOP_INFO": {
    "TITLE": "商品信息"
  },
  "AMT_INFO": {
    "TITLE": "金额信息"
  },
  "ORDER_CHARGE": {
    "TITLE": "支付信息",
    "TOTAL_MNY_TITLE": "总费用",
    "charge_title": "账单金额"
  },
  "BOX_CNT": {
    "TITLE": "箱数"
  },
  "TRK_COUNT": {
    "TITLE": "追踪数"
  },
  "TOTAL_PRO_QTY": {
    "TITLE": "总数量"
  },
  "TOTAL_PRO_COST": {
    "TITLE": "总金额"
  },
  "Clearance": {
    "TITLE": "通关类目"
  },
  "DLV": {
    "TITLE": "附加服务"
  },
  "RES_COUPON": {
    "TITLE": "已登记优惠券"
  },
  "Logistics_REQ": {
    "TITLE": "仓库要求事项"
  },
  "Order_INQ": {
    "TITLE": "订单咨询"
  },
  "Management": {
    "TITLE": "管理"
  },
  "NOTE": {
    "제목입력": "输入标题",
    "내용입력": "输入内容"
  },
  "PAYIN_DT": {
    "required": "请选择汇款日期",
    "placeholder": "汇款日期"
  },
  "PAYIN_NM": {
    "required": "请输入汇款人姓名"
  },
  "PAYIN_ACC_1": {
    "required": "请输入银行名称"
  },
  "PAYIN_ACC_2": {
    "required": "退款金额接收账户号码"
  },
  "MNY": {
    "required": "请输入金额",
    "number": "请正确输入金额",
    "max": "充值金额不能超过 100,000,000",
    "placeholder": "充值金额",
    "name": "申请金额"
  },
  "BANK_NM": {
    "title": "银行名称",
    "required": "请输入银行名称"
  },
  "ACC_NO": {
    "title": "账号",
    "required": "收款银行账户"
  },
  "ACC_HOLDER": {
    "title": "账户持有人"
  },
  "coupon": {
    "un_used": "未使用",
    "expired_coupon": "已过期",
    "returned_coupon": "已退回",
    "tip_msg": "没有可用的优惠券。",
    "cancel_msg": "您确定要取消已使用的优惠券吗？",
    "coupon_name": "优惠券名称",
    "coupon_amount": "优惠金额",
    "coupon_grant_type": "发行类型",
    "coupon_grant_kind": "发行种类",
    "coupon_valid_date": "有效日期",
    "long_term": "长期有效"
  },
  "change_lang": {
    "text": "语言切换中..."
  },
  "site_map": {
    "title": "网站地图",
    "subtitle": "快速找到您需要的服务与信息",
    "home": "首页",
    "guide_list": "指南列表",
    "account_access": "账号入口",
    "guide_description": "新手必看，快速上手",
    "purchase_description": "电商订单，快速发货",
    "lcl_description": "海运整柜与专业运输",
    "rocket_description": "中国与韩国入仓服务",
    "three_pl_description": "仓储管理与一件代发",
    "service_description": "公告、问答与包裹服务",
    "mypage_description": "订单、支付与账号管理",
    "account_description": "登录、注册与账号找回",
    "default_description": "服务与信息快捷入口"
  },
  "return_apply_process": {
    "apply_button": "申请处理",
    "dialog_title": "确认处理",
    "process_method": "处理方式",
    "select_method": "请选择处理方式",
    "select_orders": "请选择需要处理的订单",
    "complete_address": "请完整填写收件人信息",
    "unregistered_goods": "选择的订单内包含非注册商品，无法执行韩国库存入库选项。",
    "success": "申请处理成功",
    "methods": {
      "1": "废弃",
      "2": "韩国库存入库",
      "3": "韩国快递出库",
      "4": "火箭一般快递",
      "5": "火箭官方揽收快递",
      "6": "火箭官方揽收托盘"
    }
  },
  "return_from_coupang_method": {
    "1": "废弃",
    "2": "韩国库存",
    "3": "韩国快递件",
    "4": "橙火入仓一般快递",
    "5": "橙火入仓官方揽收快递",
    "6": "橙火入仓官方揽收托盘",
    "7": "待定"
  },
  "return_from_coupang_type": {
    "title": "区分",
    "COUPANG_ERROR_RETURN": "返送",
    "COUPANG_CUSTOMER_OUTBOUND": "自提"
  },
  "outbound": {
    "电商快递": "电商快递",
    "海运物流": "海运物流",
    "火箭官方快递揽收": "火箭官方快递揽收",
    "火箭官方托盘揽收": "火箭官方托盘揽收",
    "火箭一般快递": "火箭一般快递",
    "火箭官方整柜入库": "火箭官方整柜入库",
    "中国库存入库": "中国库存入库",
    "韩国库存入库": "韩国库存入库",
    "韩国3PL一件代发": "韩国3PL一件代发",
    "韩国快递出库": "韩国快递出库",
    "中国仓库退货": "中国仓库退货",
    "韩国仓库退货": "韩国仓库退货",
    "韩国返送": "韩国返送",
    "快递": "快递",
    "货车": "货车",
    "官方揽收快递": "官方揽收快递",
    "官方揽收托盘": "官方揽收托盘",
    "官方整柜入库": "官方整柜入库"
  },
  "field": {
    "sms_yes": "发送短信",
    "sms_no": "不发送短信"
  },
  "defaultStatus": {
    "expectedInbound": "预计入库",
    "partialInbound": "部分入库",
    "inboundComplete": "入库完成",
    "inTransit": "运输中",
    "errorInbound": "错误入库",
    "cancelRequested": "申请取消",
    "discarded": "废弃"
  },
  "quick_menu": {
    "close": "关闭快捷菜单",
    "expand": "展开快捷菜单",
    "collapse": "收起快捷菜单",
    "title": "服务中心",
    "subtitle": "快速选择所需服务",
    "services_title": "服务入口",
    "contact_title": "联系与咨询",
    "ecommerce_buy": "电商海运代买服务申请",
    "ecommerce_delivery": "电商海运转运服务申请",
    "lcl_buy": "LCL/FCL代买服务申请",
    "lcl_delivery": "LCL/FCL转运服务申请",
    "rocket_cn_buy": "橙火入库仓代买服务申请",
    "rocket_cn_delivery": "橙火入库仓转运服务申请",
    "rocket_kr_inbound": "韩国橙火入仓服务申请",
    "china_3pl": "中国进口3PL仓储服务申请",
    "korea_3pl": "韩国3PL仓储服务申请",
    "korea_3pl_outbound": "3PL出库申请",
    "coupang_return": "Coupang返送/自提申请",
    "inventory_outbound_records": "库存出库申请记录",
    "batch_order": "3PL出库批量下单",
    "china_order_status": "中国仓库订单状态详情",
    "korea_order_status": "韩国仓库订单状态详情",
    "youtube": "YouTube 视频入口",
    "consult_3pl": "3PL・FCL 咨询",
    "delivery_consult": "转运服务咨询",
    "buying_consult": "代买服务咨询",
    "wechat": "CHINAONE 客服微信"
  },
  "header_user_menu": {
    "welcome_back": "欢迎回来！",
    "common_services": "常用服务",
    "personal_center": "会员资料",
    "my_orders": "我的订单",
    "bill_management": "账单管理",
    "coupon_management": "优惠券管理",
    "compensation_deposit_management": "赔偿预存款管理",
    "recharge_records": "充值记录",
    "api_settings": "API设置",
    "language_current": "语言：{language}",
    "messages": "消息中心",
    "logout_title": "退出登录",
    "logout_confirm": "确定要退出当前账号吗？"
  },
  "deposit_account": {
    "recharge_title": "充值信息",
    "refund_title": "退款信息",
    "receiving_account": "收款账户",
    "label": "选择预存款账户",
    "placeholder": "请选择预存款账户",
    "china": "中国预存款账户",
    "korea": "韩国预存款账户",
    "china_balance": "中国余额",
    "korea_balance": "韩国余额",
    "charge": "充值",
    "copied": "已复制",
    "required": "请选择预存款账户",
    "refund_exceeds_balance": "退款金额不能超过当前账户余额（₩{balance}）",
    "type_cn": "预存款（中国用）申请",
    "type_kr": "预存款（韩国用）申请",
    "type_title": "预存款账户",
    "type": "预存款类型",
    "wallet_cn": "预存款（中国用）",
    "wallet_kr": "预存款（韩国用）"
  },
  "customer_service_index": {
    "use_guide": "使用指南咨询",
    "buy_service": "代买服务咨询",
    "delivery_service": "转运服务咨询",
    "work_time": "工作时间",
    "mon_fri": "周一至周五",
    "sat": "周六",
    "free_time": "午休",
    "main_phone": "联系电话"
  },
  "home_logistics": {
    "delivery_tracking": "快递单号查询",
    "china_tracking": "中国快递查询",
    "korea_tracking": "韩国快递查询",
    "sailing_schedule": "出库计划",
    "times": "次",
    "schedule_days": "周一至周五，周日",
    "deadline_title": "汇款截止时间",
    "shipping_days": "运输：周一、周三、周四、周五",
    "closed_days": "休息：周六及法定节假日"
  },
  "stock_preview": {
    "download_scope_hint": "勾选商品可查看对应明细；未勾选时，显示当前仓库全部商品。",
    "inbound": "入库明细",
    "outbound": "出库明细",
    "stock": "库存明细",
    "warehouse": "仓库",
    "sku": "SKU ID",
    "spu": "登录商品ID",
    "barcode": "商品条码",
    "product": "商品名称",
    "option": "选项名称",
    "quantity": "数量",
    "order": "订单编号",
    "enable_time": "可用时间",
    "spec": "包装规格",
    "cbm": "CBM",
    "weight": "重量（kg）",
    "out_time": "出库时间",
    "goods": "商品ID",
    "recipient": "收件人",
    "address": "地址",
    "tracking": "运单号",
    "option_id": "商品选项ID",
    "stock_qty": "库存数量",
    "out_qty": "已出库数量",
    "selected_scope": "已限定所选 {count} 个 SKU",
    "all_scope": "当前仓库全部商品"
  },
  "storage_fee_export": {
    "all_warehouses": "全部仓库",
    "all_nations": "全部国家",
    "china": "中国",
    "korea": "韩国",
    "title": "保管费用明细",
    "select_date": "选择搜索日期",
    "start_date": "开始日期",
    "end_date": "结束日期",
    "select_date_warning": "请选择搜索日期",
    "file_name": "保管费用明细",
    "download_failed": "下载失败",
    "date_order_warning": "开始日期不能晚于结束日期",
    "search_failed": "查询失败",
    "list": "费用明细",
    "date": "日期",
    "warehouse": "库存仓库",
    "bill": "账单编号",
    "box_count": "计费箱数",
    "quantity": "商品总数",
    "volume": "库存商品体积",
    "fee": "当日保管费（韩币）"
  },
  "order_fees": {
    "fee_amount": "费用金额",
    "total_goods_purchase_cost": "商品总采购费用",
    "orange_fire_storage_fee": "橙火保管费",
    "warehouse_storage_fee": "仓库保管费",
    "original_bill_number": "原账单号",
    "view_original_bill": "查看原账单",
    "storage_volume_label": "保管费计费体积",
    "exchange_rate": "汇率",
    "coupon_amount": "代金券金额",
    "refund_details": "退款明细",
    "refund_wallet": "预存款退回",
    "refund_bonus": "赔偿预存款退回",
    "refund_points": "积分退回",
    "refund_coupon": "代金券退回",
    "refund_total": "退款合计",
    "view_details": "查看明细",
    "collapse_details": "收起明细"
  },
  "upload_file": {
    "button": "上传文件",
    "size_limit": "文件大小不能超过 {size}MB",
    "delete_success": "删除成功",
    "delete_failed": "删除失败"
  },
  "receive_address": {
    "set_default_success": "设为默认成功",
    "cancel_default_success": "取消默认成功",
    "delete_confirm": "确定删除【{name}】这条收货地址吗？",
    "delete_title": "删除确认",
    "delete_success": "删除成功"
  },
  "express_package": {
    "quantity_exceeded": "不能超过组合数量",
    "enter_quantity": "请输入数量",
    "select_product": "请至少选择一个商品"
  },
  "kr_address_search": {
    "enter_keyword": "请输入地址关键字",
    "no_results": "未找到匹配的地址",
    "search_failed": "地址搜索失败"
  },
  "account_security": {
    "title": "账号安全",
    "login_password": "登录密码",
    "description": "建议定期修改密码，以提高账号安全性。修改密码前需要进行短信验证码认证。",
    "dialog_title": "修改登录密码",
    "sms_verification": "短信验证",
    "set_new_password": "设置新密码",
    "phone_tip": "为保障账号安全，修改密码前需要验证当前绑定手机号码。验证码将发送至：",
    "mobile_number": "手机号码",
    "sms_code": "短信验证码",
    "sms_code_placeholder": "请输入短信验证码",
    "get_verify_code": "获取验证码",
    "new_password": "新密码",
    "new_password_placeholder": "请输入新密码",
    "confirm_new_password": "确认新密码",
    "confirm_new_password_placeholder": "请再次输入新密码",
    "confirm_change": "确认修改",
    "code_sent": "验证码已发送",
    "sms_code_required": "请输入短信验证码",
    "new_password_required": "请输入新密码",
    "confirm_password_required": "请再次输入新密码",
    "password_mismatch": "两次输入的新密码不一致",
    "change_success": "密码修改成功"
  },
  "cooperation": {
    "title": "合作管理",
    "member_name": "会员姓名",
    "member_code": "会员编号",
    "invited_total": "邀请注册人数",
    "outbound_total": "累计出库完成",
    "performance_total": "累计业绩",
    "commission_total": "佣金代付金额",
    "commission_details": "佣金支付明细",
    "performance_details": "业绩明细",
    "receiving_account": "佣金收款账户",
    "bank_name": "收款银行",
    "bank_account": "银行账号",
    "account_holder": "开户名",
    "verify_code": "验证码",
    "get_verify_code": "获取验证码",
    "change_bank_account": "银行账户变更",
    "bank_verify_title": "银行账户变更验证",
    "bank_verify_tip": "为保障账户安全，请先完成身份验证。",
    "bank_verify_phone_tip": "为保障账户安全，验证码发送至当前绑定手机号码：",
    "enter_verify_code": "请输入验证码",
    "change": "变更",
    "verify_code_sent": "验证码已发送",
    "complete_bank_account": "请完整填写银行卡信息",
    "complete_bank_form": "请完整填写银行卡信息和验证码",
    "year": "年",
    "month": "月份",
    "month_unit": "月",
    "outbound_completed": "出库完成",
    "performance_amount": "业绩金额",
    "commission_amount": "佣金金额",
    "settled": "已结算",
    "pending_settlement": "佣金待付",
    "transfer_receipt": "转账凭证",
    "view_info": "查看信息",
    "detail": "详情",
    "outbound_date": "出库日期",
    "subtotal": "小计",
    "performance": "业绩",
    "total": "合计",
    "start_date": "开始日期",
    "end_date": "结束日期",
    "recommend_code": "推荐码",
    "settlement_amount": "结算金额",
    "bind_date": "推荐码绑定日",
    "number": "No"
  },
  "ecommerce_sync": {
    "title": "平台商品同步",
    "account": "电商平台账号",
    "select_account": "请选择平台账号",
    "no_api_account": "尚未配置 Coupang API",
    "no_api_notice": "未检测到可用的 Coupang 平台账号，请先添加并验证 API 信息。",
    "api_required_title": "请先添加 Coupang API",
    "api_required_description": "添加并验证 Coupang API 信息后，即可返回此页面选择平台账号并拉取商品。",
    "go_add_api": "去添加 API",
    "accounts_load_failed": "平台账号加载失败",
    "accounts_load_failed_description": "暂时无法获取平台账号，请检查网络后重试。",
    "retry": "重新加载",
    "pull_products": "拉取商品",
    "notice": "需要在 API 管理页面提交 API 信息并成功绑定平台店铺后才可同步商品；若绑定成功后仍无法同步，请及时联系客服。",
    "pending_products": "待注册商品",
    "summary": "共 {products} 个商品，{skus} 个 SKU",
    "empty": "请选择平台账号并拉取商品",
    "product_and_option": "商品名称/选项名",
    "barcode_id": "商品条码ID",
    "no_image": "无图",
    "platform_product_name": "平台商品名称",
    "search_customs_item": "搜索通关商品",
    "select_customs_item": "请选择通关商品",
    "product_name_en": "商品英文名",
    "load_next": "继续拉取下一页",
    "all_loaded": "已加载全部商品",
    "pull_success": "成功拉取 {count} 个商品",
    "no_products": "没有可拉取的商品",
    "register_success": "商品注册成功",
    "register_failed": "商品注册失败",
    "validation": {
      "product_name": "商品 {product} 请填写商品名称",
      "keep_sku": "商品 {product} 至少保留一个 SKU",
      "platform_product_name": "商品 {product} 的 SKU {sku} 请填写平台商品名称",
      "barcode": "商品 {product} 的 SKU {sku} 请填写商品条码",
      "composition": "商品 {product} 的 SKU {sku} 缺少商品构成",
      "customs_item": "商品 {product} 的 SKU {sku} 请选择通关商品",
      "product_name_en": "商品 {product} 的 SKU {sku} 请填写商品英文名"
    }
  },
  "api_settings": {
    "title": "API 管理",
    "description": "管理第三方电商平台 API，用于订单同步、物流及相关业务数据对接。",
    "add_api": "添加 API",
    "added": "已添加",
    "connected": "正常连接",
    "abnormal": "异常",
    "all_platforms": "全部平台",
    "all_statuses": "全部状态",
    "platform": "平台",
    "client_id": "企业代码 / Client ID",
    "access_key": "Access Key / Client Key",
    "secret_key": "Secret Key",
    "credential_expire_time": "凭证有效期",
    "credential_expire_placeholder": "请选择平台显示的到期时间",
    "credential_expire_help": "Key/Secret、Token 均按此时间判断正常、临期或过期；平台未提供时可留空。",
    "no_expire_time": "未提供有效期",
    "enable": "启用",
    "enabled": "启用",
    "connection_status": "连接状态",
    "last_test_time": "最后验证时间",
    "actions": "操作",
    "edit": "修改",
    "test": "测试",
    "testing": "测试中",
    "delete": "删除",
    "status_connected": "正常",
    "status_failed": "异常",
    "status_untested": "未测试",
    "status_disabled": "停用",
    "empty": "暂无平台账号",
    "mask_tip": "敏感密钥仅以掩码形式展示。修改时无需回显完整 Secret Key。",
    "load_failed": "平台账号加载失败",
    "add_dialog_title": "添加 API",
    "edit_dialog_title": "修改 {platform} API",
    "company_code": "企业代码",
    "company_code_placeholder": "请输入企业代码",
    "company_code_help": "{platform} 企业识别代码。",
    "access_key_placeholder": "请输入 Access Key",
    "secret_key_placeholder": "请输入 Secret Key",
    "key_unchanged_placeholder": "如不修改，请留空",
    "secret_key_help": "Secret Key 将加密保存，保存后仅显示掩码。",
    "test_connection": "测试连接",
    "test_untested": "尚未验证 API 连接",
    "test_untested_help": "建议保存前先测试凭证是否有效。",
    "test_success": "API 连接正常",
    "test_success_help": "平台 API 凭证验证成功。",
    "test_failed": "API 连接失败",
    "test_failed_help": "请检查企业代码和 API 密钥后重试。",
    "required_field": "该项为必填项",
    "cancel": "取消",
    "save": "保存",
    "save_success": "平台账号添加成功",
    "save_failed": "平台账号添加失败",
    "detail_load_failed": "平台账号详情加载失败",
    "update_success": "平台账号修改成功",
    "update_failed": "平台账号修改失败",
    "enable_success": "平台 API 已启用",
    "disable_success": "平台 API 已停用",
    "enable_update_failed": "启用状态修改失败",
    "delete_confirm": "确定删除 {platform} 平台账号“{account}”吗？",
    "delete_success": "平台账号删除成功",
    "delete_failed": "平台账号删除失败"
  },
  "kakao_oauth": {
    "processing_title": "正在处理 Kakao 登录",
    "processing_hint": "请稍候，不要关闭此窗口。",
    "link_accounts_aria": "绑定 ChinaOne 与 Kakao 账号",
    "first_login_title": "首次使用 Kakao 登录",
    "bind_intro": "请验证已注册的 ChinaOne 会员账号，绑定后可直接使用 Kakao 登录。",
    "verify_method_aria": "选择验证方式",
    "mobile_verification": "手机验证",
    "email_verification": "邮箱验证",
    "mobile_placeholder": "请输入已注册手机号",
    "email_placeholder": "请输入已注册邮箱",
    "code_placeholder": "请输入验证码",
    "get_code": "获取验证码",
    "countdown": "{seconds}s",
    "bind_and_login": "验证并绑定登录",
    "no_account": "还没有 ChinaOne 账号？",
    "register_first": "先注册",
    "register_tip": "注册完成后，请重新点击 Kakao 登录进行绑定。",
    "login_failed_title": "Kakao 登录失败",
    "return_login": "返回登录",
    "invalid_callback": "Kakao 登录回调参数无效，请重新登录。",
    "login_failed_default": "Kakao 登录失败，请重新尝试。",
    "authorization_cancelled": "你已取消 Kakao 授权。",
    "authorization_failed": "Kakao 授权失败。",
    "mobile_required": "请输入手机号",
    "mobile_invalid": "请输入正确的韩国手机号",
    "email_required": "请输入邮箱",
    "email_invalid": "请输入正确的邮箱地址",
    "code_sent": "验证码已发送",
    "code_send_failed": "验证码发送失败",
    "get_code_first": "请先获取验证码",
    "target_changed": "{target}已改变，请重新获取验证码",
    "mobile": "手机号",
    "email": "邮箱",
    "code_required": "请输入验证码",
    "bind_failed": "绑定失败，请重试"
  },
  "bbs": {
    "notice_description": "最新通知、常见问题解答及活动信息都在这里，欢迎查看。",
    "notice_center": "公告中心",
    "notice_center_description": "请选择要查看的公告分类。",
    "notice_category_count": "共 {count} 个分类",
    "notice_category_hint": "查看该分类下的公告内容",
    "notice_category_empty": "暂无公告分类",
    "notice_category_load_failed": "公告分类加载失败，请稍后重试",
    "home": "首页",
    "detail": "公告详情",
    "breadcrumb": "面包屑导航"
  },
  "package_product_register": {
    "confirm_title": "确认申请",
    "use_coupang_barcode_as_sku": "是否需要将 Coupang 条码作为 SKU ID？",
    "select_product": "请先选择要注册的商品",
    "missing_platform_info": "组合 {code} 缺少完整的平台商品信息，请先编辑",
    "user_missing": "未获取到用户信息，无法注册商品",
    "success": "商品注册成功，可在商品管理中查看",
    "failed": "商品注册失败"
  },
  "parcelStatus": {
    "pendingInbound": "待入库",
    "signed": "已签收",
    "inbound": "已入库"
  },
  "history_order": {
    "search_code": "订单编号 / 商品编号 / SKU ID / 商品条码编号",
    "basic_product": "基础商品",
    "registered_product": "注册商品",
    "stock_product": "库存",
    "stock_selection_tip": "库存商品无法在此选择，请使用【库存下单】功能",
    "basic_product_tip": "此处选择的商品将按基础商品添加至订单。如需使用注册商品信息，请使用【注册商品下单】功能。",
    "order_code": "订单编号",
    "goods_code": "商品编号",
    "sku_id": "SKU ID",
    "start_date": "开始日期",
    "end_date": "结束日期",
    "empty": "暂无历史订单",
    "order_fallback": "订单",
    "expand": "选择商品",
    "collapse": "收起商品",
    "select_col": "选择",
    "image_col": "图片",
    "goods_col": "商品信息",
    "option_col": "颜色 / 尺码",
    "no_image": "暂无图片",
    "goods_code_label": "商品编号",
    "sku_label": "SKU",
    "barcode_label": "条码",
    "selected_summary": "已选择 {count} 件商品",
    "scope_tip": "仅显示与当前下单页同仓库、同运输方式的历史订单",
    "select_first": "请先选择需要回填的商品",
    "opener_closed": "下单页面已关闭或不可用，无法回填商品"
  }
}
